export const RESOURCE = 'adminredemptionrequest';
export const ACTIONS = { GetByReferenceId: '/referenceId', CancelByReferenceId: '' }